
import * as __star__ from 'uuid';

const {

NIL,
parse,
stringify,
v1,
v3,
v4,
v5,
validate,
version,
__esModule
} = __star__;

export {
NIL,
parse,
stringify,
v1,
v3,
v4,
v5,
validate,
version,
__esModule
};

